export default JSON.parse(atob(process.env.VUE_APP_FCM_PLATFORM_CONFIG_B64))
